import { render, staticRenderFns } from "./HeadItemForAll.vue?vue&type=template&id=4a607186&scoped=true"
import script from "./HeadItemForAll.vue?vue&type=script&lang=js"
export * from "./HeadItemForAll.vue?vue&type=script&lang=js"
import style0 from "./HeadItemForAll.vue?vue&type=style&index=0&id=4a607186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a607186",
  null
  
)

export default component.exports